// src/Services/pharmacyService.js
import apiClient from "../api/apiClient";

export const PharmacyService = {
  /**
   * 1. Get Pharmacy Dispensing Queue
   * @param {Object} params - { status, department, search, date, page, limit }
   */
  async getQueue(params = {}) {
    const {
      status = "ALL",
      department = "",
      search = "",
      date = "",
      page = 1,
      limit = 50,
    } = params;

    const queryParams = new URLSearchParams();
    if (status && status !== "ALL") {
      queryParams.append("status", status.toUpperCase());
    }
    if (department && department !== "All" && department !== "All Departments") {
      queryParams.append("department", department);
    }
    if (search && search.trim()) {
      queryParams.append("search", search.trim());
    }
    if (date) {
      queryParams.append("date", date);
    }
    if (page) {
      queryParams.append("page", String(page));
    }
    if (limit) {
      queryParams.append("limit", String(limit));
    }

    const queryString = queryParams.toString();
    const url = `/pharmacy/queue${queryString ? `?${queryString}` : ""}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * 2. Get Clinical Prescription by Visit ID (for Dispensing Modal)
   * @param {string} visitId
   * @param {string} [patientId]
   */
  async getPrescriptionByVisit(visitId, patientId) {
    if (!visitId) {
      throw new Error("visitId is required to fetch prescription.");
    }
    let url = `/visit/${visitId}/clinical/prescription`;
    if (patientId) {
      url += `?patientId=${encodeURIComponent(patientId)}`;
    }
    const response = await apiClient.get(url);
    return response.data;
  },

  /**
   * 3. Submit Dispense Transaction
   * @param {Object} payload - { visit_id, patient_id, pharmacist_notes, safety_checklist, items }
   */
  async submitDispense(payload) {
    const response = await apiClient.post("/pharmacy/dispense", payload);
    return response.data;
  },

  /**
   * 4. Get Dispense Record by Visit ID (for Receipt Printing)
   * @param {string} visitId
   */
  async getDispenseRecord(visitId) {
    if (!visitId) {
      throw new Error("visitId is required to fetch dispense record.");
    }
    const response = await apiClient.get(`/pharmacy/dispense/by-visit/${visitId}`);
    return response.data;
  },
};

export default PharmacyService;
